import React from "react";
import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";

import SectionTitle from "../home/SectionTitle";

const CHIPS = [
  { titleKey: "trading.details.c1.title", textKey: "trading.details.c1.text" },
  { titleKey: "trading.details.c2.title", textKey: "trading.details.c2.text" },
  { titleKey: "trading.details.c3.title", textKey: "trading.details.c3.text" },
  { titleKey: "trading.details.c4.title", textKey: "trading.details.c4.text" },
  { titleKey: "trading.details.c5.title", textKey: "trading.details.c5.text" },
  { titleKey: "trading.details.c6.title", textKey: "trading.details.c6.text" },
];

function Details() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer">
        <div className="flex flex-col lg:flex-row gap-[25px] lg:gap-[35px] items-start">
          <div className="lg:w-[383px] shrink-0">
            <SectionTitle
              title1={t("trading.details.title1")}
              title2={t("trading.details.title2")}
              text={t("trading.details.subtitle")}
              align="left"
            />
          </div>

          <div className="flex-1 w-full grid grid-cols-2 lg:grid-cols-3 gap-[7px] lg:gap-[12px]">
            <Fade cascade triggerOnce direction="up" damping={0.06}>
              {CHIPS.map((chip) => (
                <div
                  key={chip.titleKey}
                  className="bg-[#f8faff] rounded-[20px] p-[20px] flex flex-col items-center justify-center gap-[8px] lg:gap-[15px] text-center"
                >
                  <p className="font-['Inter'] font-bold text-[16px] text-[#1c385f]">
                    {t(chip.titleKey)}
                  </p>
                  <p className="font-['Inter'] font-normal text-[14px] leading-[1.5] text-[#435c7f]">
                    {t(chip.textKey)}
                  </p>
                </div>
              ))}
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Details;
